function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { AwsErrors } from '../config/aws-errors';
var normalizeValue = function(value) {
    return value !== null && value !== void 0 ? value : '';
};
var AwsService = /*#__PURE__*/ function() {
    "use strict";
    function AwsService() {
        _class_call_check(this, AwsService);
    }
    _create_class(AwsService, [
        {
            key: "translateAWSErrors",
            value: function translateAWSErrors(error, i18n, context) {
                var awsError = AwsErrors.find(function(ae) {
                    return ae.errorCode === error && normalizeValue(ae.context) === context;
                });
                if (awsError) {
                    return i18n.t(awsError.errorMessage);
                }
                return i18n.t('common.alert.somethingWrong');
            }
        }
    ]);
    return AwsService;
}();
export var awsService = new AwsService();
